import React, { ReactElement } from "react";
import {
  FareCardHeader,
  FareCardHeaderProps
} from "../FareCardHeader/FareCardHeader";
import {
  FareCardBase,
  FareCardBaseContent,
  FareCardBaseProps
} from "../FareCardBase";
import {
  FareCardFooter,
  FareCardFooterProps
} from "../FareCardFooter/FareCardFooter";
import { FareCardRefundability } from "../FareCardRefundability";
import { BlockContentValue } from "../../UnstyledBlockContent/UnstyledBlockContent";
import { FareInfographic, StepsGroup } from "../../FareInfographic";

export type StaticFareCardProps = FareCardBaseProps & {
  steps: StepsGroup[];
  headerProps: FareCardHeaderProps & {
    additionalComponent?: ReactElement;
    refundabilityContent?: BlockContentValue;
    isRefundable?: boolean;
  };
  footerProps?: FareCardFooterProps & {
    component?: ReactElement;
    content?: ReactElement;
  };
};

export const StaticFareCard: React.FC<StaticFareCardProps> = ({
  steps,
  headerProps,
  footerProps,
  ...cardProps
}) => {
  const {
    additionalComponent,
    refundabilityContent,
    isRefundable = false,
    ...otherHeaderProps
  } = headerProps;
  const {
    component: footerComponent,
    content: footerContent,
    ...otherFooterProps
  } = footerProps || {};

  return (
    <FareCardBase {...cardProps}>
      <FareCardHeader {...otherHeaderProps}>
        <div>
          <FareCardRefundability
            isRefundable={isRefundable}
            content={refundabilityContent}
          />
          {additionalComponent}
        </div>
      </FareCardHeader>
      <FareCardBaseContent>
        <FareInfographic steps={steps} expandable={false} />
      </FareCardBaseContent>
      {!footerComponent && (otherFooterProps || footerContent) && (
        <FareCardFooter {...otherFooterProps}>{footerContent}</FareCardFooter>
      )}
      {footerComponent && <React.Fragment>{footerComponent}</React.Fragment>}
    </FareCardBase>
  );
};
